import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

/**
 * Password input with an eye toggle to reveal/hide the value.
 *
 * Drop-in replacement for `<Input type="password" />` — takes every prop the
 * underlying shadcn Input accepts, plus:
 *  - `testId` (adds data-testid on the toggle button; input keeps its own testid)
 *  - `containerClassName` (className for the wrapper div)
 */
export const PasswordInput = forwardRef(function PasswordInput(
  { className = "", containerClassName = "", testId, ...props },
  ref
) {
  const [visible, setVisible] = useState(false);
  return (
    <div className={`relative ${containerClassName}`}>
      <Input
        ref={ref}
        type={visible ? "text" : "password"}
        className={`pr-10 ${className}`}
        {...props}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
        data-testid={testId || "password-toggle"}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-muted-foreground hover:text-foreground transition-colors"
        tabIndex={-1}
      >
        {visible ? <EyeOff className="h-4 w-4" strokeWidth={1.7} /> : <Eye className="h-4 w-4" strokeWidth={1.7} />}
      </button>
    </div>
  );
});
